var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "modal-card modal-card--md modal-card--modern" },
    [
      _c("header", { staticClass: "modal-card-head" }, [
        _c("p", { staticClass: "modal-card-title" }, [_vm._v(" Oops ")]),
        _c(
          "a",
          {
            staticClass: "close-modal",
            attrs: { "aria-label": "close" },
            on: {
              click: function ($event) {
                return _vm.closeModal()
              },
            },
          },
          [_c("i", { staticClass: "material-icons" }, [_vm._v("close")])]
        ),
      ]),
      _c("section", { staticClass: "modal-card-body" }, [
        _c("p", [
          _vm._v(
            " We can't recognise what company you're trying to join from your email address. "
          ),
        ]),
        _c("p", [
          _vm._v(
            " If your company is already signed up, make sure you are signing in using your company email address, and ask your company admin to ensure your email domain is on their whitelist. "
          ),
        ]),
        _c("p", [
          _vm._v(
            " If you don't know your company admin, or you're a new company, please contact us for the next steps. "
          ),
        ]),
        _c("div", { staticClass: "flexbox-center button-row" }, [
          _c(
            "button",
            {
              staticClass: "button button-medium button-grey button-outline",
              attrs: { id: "close-button" },
              on: {
                click: function ($event) {
                  return _vm.closeModal()
                },
              },
            },
            [_vm._v(" Close ")]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }